<template>
  <transition name="fade">
    <div v-if="show" class="modal">
      <div class="modal__backdrop" @click="close()" />

      <div
        ref="modalContainer"
        :class="'modal__dialog ' + classes.modalDialog"
        :aria-hidden="show ? 'false' : 'true'"
        @click.stop
        @keydown="checkKeyEvent"
      >
        <div :class="'modal__header ' + classes.modalHeader">
          <slot name="header" />
          <div class="modal__close">
            <button
              v-if="showClose"
              v-focus
              role="button"
              aria-label="Close"
              :class="classes.modalButton"
              @keydown.esc="close()"
              @click="close()"
            >
              &#x2715;
            </button>
          </div>
        </div>

        <div :class="'modal__body ' + classes.modalBody">
          <slot name="body" />
        </div>

        <div :class="'modal__footer ' + classes.modalFooter">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalComponent',
  directives: {
    focus: {
      // directive definition
      inserted(el) {
        el.focus()
      },
    },
  },
  props: {
    hideOverflow: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: Object,
      default: () => ({
        modalBody: '',
        modalDialog: '',
        modalFooter: '',
        modalHeader: '',
        modalButton: '',
      }),
    },
  },
  emits: ['closed'],
  watch: {
    show: {
      handler(isVisible, wasVisible) {
        if (!this.hideOverflow) {
          return
        }

        if (isVisible) {
          document.querySelector('body').classList.add('overflow-hidden')
        } else {
          document.querySelector('body').classList.remove('overflow-hidden')
        }
      },
    },
  },
  methods: {
    checkKeyEvent(event) {
      // close modal and return early if escape
      if (event.key === 'Escape') {
        this.close()
      }
      const focusableList = this.$refs.modalContainer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      )
      // escape early if only 1 or no elements to focus
      if (focusableList.length < 2 && event.key === 'Tab') {
        event.preventDefault()
        return
      }
      // capture tab focus so it doesn't leave the modal while it is open
      const last = focusableList.length - 1
      if (
        event.key === 'Tab' &&
        event.shiftKey === false &&
        event.target === focusableList[last]
      ) {
        event.preventDefault()
        focusableList[0].focus()
      } else if (
        event.key === 'Tab' &&
        event.shiftKey === true &&
        event.target === focusableList[0]
      ) {
        event.preventDefault()
        focusableList[last].focus()
      }
    },
    close() {
      this.$emit('closed')
    },
  },
}
</script>
